import React from "react";
import { Card, Dropdown } from "react-bootstrap";
import TauriImage from "../TauriImage/TauriImage";
import './OpalAccordionCardV3.css';

const OpalAccordionCardV3 = ({
    item,
    selectedCard,
    setSelectedCard,
    search,
    onSelectItem,
    onDeleteItem
}) => {
    const highlightText = (text, query) => {
        if (!query) return text;
        const regex = new RegExp(`(${query})`, "gi");
        return text.split(regex).map((part, index) =>
            part.toLowerCase() === query.toLowerCase() ? (
                <span key={index} className="highlighted-text">{part}</span>
            ) : (
                part
            )
        );
    };

    const dateItems = item?.Dates?.length > 0 ? item.Dates : ["No Schedule"];

    return (
        <Card key={item.ID} className="card-v3 mb-2">
            <div
                className={`custom-card card-body ${selectedCard === item.ID ? "active-card" : ""} p-2`}
                onClick={() => {
                    setSelectedCard(item.ID);
                }}
            >
                <TauriImage
                    localImage={"/Images/mdi--users.svg"}
                    className={"add-icon"}
                    alt="icon"
                    onClick={(e) => {
                        e.stopPropagation();
                        setSelectedCard(item.ID);
                        // onSelectItem?.(item);
                    }}
                />
                <div className="d-flex align-items-center">
                    <Dropdown className="circle-dropdown">
                        <Dropdown.Toggle
                            className="circle-toggle d-flex align-items-center">
                            <div className="circle-counter flex-shrink-0 me-3 me-md-2 me-lg-3">
                                {item?.Dates?.length || 0}/{item?.Customer?.Frequency_count || 0}
                            </div>
                        </Dropdown.Toggle>

                        <Dropdown.Menu
                            className="p-2 circle-menu"
                            popperConfig={{
                                strategy: "fixed", // ignore parent overflow
                                modifiers: [
                                    {
                                        name: "preventOverflow",
                                        options: {
                                            boundary: "viewport", // stay in viewport
                                        },
                                    },
                                ],
                            }}>
                            {dateItems.map((date, index) => (
                                date === "No Schedule" ? (
                                    <div
                                        key={index}
                                        className={`d-flex align-items-center circle-item no-hover p-2 fw-bold text-muted`}
                                    >
                                        <span className="ms-2">{date}</span>
                                    </div>
                                ) : (
                                    <Dropdown.Item
                                        as={"div"}
                                        key={index}
                                        className={`d-flex align-items-center justify-content-between circle-item p-2 ${index % 2 === 1 ? "alt-bg" : ""}`}
                                    >
                                        <span className="ms-2">{date}</span>
                                        <TauriImage
                                            localImage="/Images/delete-icon.svg"
                                            alt="icon"
                                            onClick={(e) => {
                                                e.stopPropagation(); // prevent dropdown close
                                                onDeleteItem?.(item.ID, date);
                                            }}
                                        />
                                    </Dropdown.Item>
                                )
                            ))}
                        </Dropdown.Menu>
                    </Dropdown>
                    <Card.Title>
                        <div className="acc-code">{highlightText(item?.Code?.toUpperCase(), search)}</div>
                        {highlightText(item?.Name?.toUpperCase(), search)}
                    </Card.Title>
                </div>
            </div>
        </Card>
    );
};

export default OpalAccordionCardV3;
